import { Link } from 'react-router-dom'

export default function Dashboard() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Photo Match Dashboard</h1>
        <p className="mt-2 text-gray-600">
          AI-powered dermatology image matching for clinical decision support
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Quick Search</h3>
          <p className="mt-2 text-sm text-gray-600">
            Find similar cases by uploading a reference image
          </p>
          <Link
            to="/search"
            className="mt-4 inline-flex items-center px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
          >
            Start Search
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Upload Images</h3>
          <p className="mt-2 text-sm text-gray-600">
            Add new patient images to the database
          </p>
          <Link
            to="/upload"
            className="mt-4 inline-flex items-center px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
          >
            Upload Now
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">API Status</h3>
          <p className="mt-2 text-sm text-gray-600">
            Connected to Photo Match API
          </p>
          <div className="mt-4 flex items-center">
            <span className="h-3 w-3 rounded-full bg-green-400 mr-2"></span>
            <span className="text-sm text-gray-700">Healthy</span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">How It Works</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="text-3xl mb-2">1</div>
            <h3 className="font-medium text-gray-900">Upload Image</h3>
            <p className="text-sm text-gray-600 mt-1">
              Upload a dermatology image you want to match
            </p>
          </div>
          <div>
            <div className="text-3xl mb-2">2</div>
            <h3 className="font-medium text-gray-900">AI Processing</h3>
            <p className="text-sm text-gray-600 mt-1">
              CLIP model generates visual embeddings
            </p>
          </div>
          <div>
            <div className="text-3xl mb-2">3</div>
            <h3 className="font-medium text-gray-900">Find Matches</h3>
            <p className="text-sm text-gray-600 mt-1">
              pgvector finds visually similar cases
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
